import { UiTheme } from '@jarvis/react-setup-and-onboarding-addons'
import { Stack } from '@jarvis/web-stratus-client'

import { ConfigStoreType } from '@/stores/config/types'
import { createReactStore } from '@/utils/create-react-store'

export const DEFAULT_LOCALE = {
  country: 'us',
  language: 'en',
}

export const ConfigStore = createReactStore<ConfigStoreType>(() => ({
  stack: Stack.pie,
  locale: DEFAULT_LOCALE,
  ui: UiTheme.hpsmart,
  appSessionId: undefined,
}))
